import CardEdit from './CardEdit';

export default CardEdit;